import React, { useState, useEffect } from "react";
import { Router } from "@reach/router";
import Layout from "../../../components/Layout";
import SEO from "../../../components/SEO";
import { navigate, Link } from "gatsby"
import Zacatek from "./Zacatek";
import ProKoho from "./ProKoho";
import Lite from "./Lite";
import UzZemrel from "./UzZemrel";
import CoNejrychleji from "./CoNejrychleji";
import Region from "./Region";
import Pohreb from "./Pohreb";
import Netradicni from "./Netradicni";
import Konec from "./Konec";
import LoadingKruh from "../../../assets/img/loadingTransparent.svg";
import styled from "styled-components";



const LoadingObrazek = styled.img`
  margin-left: calc(50% - 100px);
  margin-top: 100px;
  width: 200px;
`;

// const Default = () => {
//   navigate("/404/");
//   return (<></>);
// }


const Redirect = ({url}) => {
  navigate(url);
  return (<></>);
}



const DotaznikInner = ({login}) => {

  const [userData, setUserData] = useState({});
  const [isLoaded, setIsLoaded] = useState(false);

  function updateData(dataInput) {
    setUserData(dataInput);
    console.log(userData);
  }

  useEffect(() => {

    if (window.location.pathname !== "/nabidka/dotaznik/") {
      navigate('/nabidka/dotaznik/');
      console.log("naviguju");
    }

    setIsLoaded(true);


	}, []);

  if (isLoaded) {
    return (<>
      <SEO
        title="Sestavte si pohřeb podle svých představ | Goodbye.cz"
        noindex
      />

      <Router basepath="/nabidka/dotaznik/">

        {/* Sem nastrkat všechny možný screeny v dotazníku, zkopírovat */}


        <Zacatek
          path="/"
          userData={userData}
          updateData={updateData}
        />

        <Zacatek
          default
          userData={userData}
          updateData={updateData}
        />

        {/* <ProKoho
          path="/pro-koho"
          userData={userData}
          updateData={updateData}
        /> */}

        <UzZemrel
          path="/stav-blizkeho/"
          userData={userData}
          updateData={updateData}
        />

        <CoNejrychleji
          path="/co-nejrychleji/"
          userData={userData}
          updateData={updateData}
        />

        <Region
          path="/region/"
          userData={userData}
          updateData={updateData}
        />

        <Lite
          path="/lite/"
          userData={userData}
          updateData={updateData}
        />

        <Pohreb
          path="/pohreb/"
          userData={userData}
          updateData={updateData}
        />

        <Netradicni
          path="/netradicni/"
          userData={userData}
          updateData={updateData}
        />

        <Konec
          path="/konec/"
          userData={userData}
          updateData={updateData}
          login={login}
        />
        
      </Router>
    </>)
  }

  else {
    return (<LoadingObrazek src={LoadingKruh} alt="Načítání" />)
  }
}

export default DotaznikInner